













































































  import { Component, Vue, Prop, Watch } from "vue-property-decorator";
  import { TermInitial, Service, Term } from "../store/store.types";
  import axios from "axios";
  import { HOST, API_URL } from "@/global";
  import { Printd } from "printd";
  import ScrollableContainer from "vue-scrollable-container";
  // import html2canvas from "html2canvas";
  // import printJS from "print-js";
  import html2pdf from "html2pdf.js";

  @Component({
      name: "IncoTerms",
      components: { ScrollableContainer },
  })
  export default class IncoTerms extends Vue {
      @Prop() compData!: any;
      public termData: TermInitial[] | null = null;
      public serviceData: Service[] | null = null;
      private d: Printd = new Printd();

      cssText: string = `
  .gf-table {
    border:1px solid #000;
    border-collapse:collapse;
    text-align:center;
    font-size:80%;
    page-break-after:auto;
    background-color: #ff0000;
    width: 990px;
    height: 10px !important;
  }
  td,tr{
    page-break-inside:avoid;
    page-break-after:auto;
  }
  .gf-red{
    padding:10px 0;
    background-color: #ff0000;
  }
  .gf-table tr .gf-buyer {
    color: #000;
    text-transform: uppercase;
    // background-color: #ff0000 !important;
    // -webkit-print-color-adjust: exact;
  }
`;

      getData() {
          axios.get(`${API_URL}/others/term-initial/`).then(({ data }) => {
              this.termData = data;
          });
          axios.get(`${API_URL}/others/services/`).then(({ data }) => {
              this.serviceData = data;
          });
      }

      printTable() {
          console.log("printing...", this.$refs.print);
          (this.$refs.print as HTMLElement).classList.add("print");
          html2pdf(this.$refs.print, {
              margin: 10,
              filename: "incoterms.pdf",
              pagebreak: { mode: "css" },
              image: { type: "jpeg", quality: 0.98 },
              html2canvas: { scale: 2, letterRendering: true },
              jsPDF: { unit: "mm", format: "A4", orientation: "landscape" },
          }).then(() => {
              (this.$refs.print as HTMLElement).classList.remove("print");
          });
      }

      get allDataAvailable() {
          return this.termData != null && this.serviceData != null;
      }

      get salesTerms(): Term[] | null {
          if (this.termData == null) {
              return null;
          } else {
              const data: Term[] = [];
              this.termData.map((item: TermInitial) => {
                  data.push(...item.terms);
              });
              return data;
          }
      }

      // printTable(): void {
      //   // this.d.print(this.$refs.print as HTMLElement, [this.cssText2]);
      //   printJS(HOST + "/generated/incoterms.pdf");
      // }

      initiateScrollHint(el: any) {
          console.log(el);
      }

      mounted() {
          this.getData();
      }
  }
